import Grid from '@mui/material/Grid2';
import { KeycloakContext } from "@keycloak/keycloak-ui-shared";
import {
    StyledEmailIcon,
    StyledPlaceIcon,
    UserAvatar,
    userInfoBoxStyles,
    userInfoGridContainerStyles,
    userInfoGridStyles,
    UserNameHeader
} from './styles';
import { Box, Stack, Typography } from '@mui/material';
import { TFunction } from 'i18next';
import { Environment } from '../../environment';
import { loggedInUserName } from '../../root/Header';

interface UserInfoProps {
    t: TFunction;
    kcContext: KeycloakContext<Environment>;
    country?: string;
    personalEmail: string;
}

export default function UserInfo({t, kcContext, country, personalEmail}: UserInfoProps) {
    const picture = kcContext.keycloak.idTokenParsed?.picture;

    return (
        <Grid container spacing={3} sx={userInfoGridContainerStyles}>
          <Grid size="auto">
            <UserAvatar alt={t("avatar")} src={picture} />
          </Grid>
          <Grid size="grow" sx={userInfoGridStyles}>
            <Stack spacing={1}>
                <UserNameHeader variant="h4">{loggedInUserName(kcContext.keycloak.idTokenParsed, t)}</UserNameHeader>
                <Grid container spacing={2}>
                  <Box sx={userInfoBoxStyles}>
                      <StyledEmailIcon /> <Typography variant="body2">{personalEmail}</Typography>
                  </Box>
                  {country && (<Box sx={userInfoBoxStyles}>
                      <StyledPlaceIcon /> <Typography variant="body2">{country}</Typography>
                  </Box>)}
                </Grid>
            </Stack>
          </Grid>
        </Grid>
    );
}